import { render, staticRenderFns } from "./UserRegValidateComponent.vue?vue&type=template&id=11124dba&scoped=true"
import script from "./UserRegValidateComponent.vue?vue&type=script&lang=js"
export * from "./UserRegValidateComponent.vue?vue&type=script&lang=js"
import style0 from "./UserRegValidateComponent.vue?vue&type=style&index=0&id=11124dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11124dba",
  null
  
)

export default component.exports